import { useState, useEffect } from "react";
import Loader from "./Loader";

import { API_BASE_URL } from "../config";

import closeIcon from "../assets/close-icon.svg";

export default function SearchSkillsAll({ handleSkillsChange, details }) {
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [jobTypes, setJobTypes] = useState([]);
  const [jobTypeLoading, setJobTypeLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchJobTypes = async () => {
      setJobTypeLoading(true);
      const response = await fetch(`${API_BASE_URL}/job-types-with-skills`);

      if (!response.ok) {
        return {
          error: response.message || "Failed to fetch job types.",
        };
      }

      const data = await response.json();
      setJobTypes(data.data);
      setJobTypeLoading(false);
    };

    fetchJobTypes();
  }, []);

  const handleSkillToggle = (id) => {
    setSelectedSkills((prev) =>
      prev.includes(id)
        ? prev.filter((skillId) => skillId !== id)
        : [...prev, id]
    );
  };

  useEffect(() => {
    if (
      details.skills &&
      details.skills.length > 0 &&
      selectedSkills.length === 0
    ) {
      const skillIds = details.skills.map((skill) =>
        typeof skill === "object" ? skill.id : skill
      );
      setSelectedSkills(skillIds);
    }
  }, [details.skills]);

  useEffect(() => {
    const selectedObjects = selectedSkills
      .map((id) => jobTypes.flatMap((jt) => jt.skills).find((s) => s.id === id))
      .filter(Boolean);

    handleSkillsChange(selectedObjects);
  }, [selectedSkills, jobTypes]);

  const hasAnyMatch = jobTypes.some((jobType) =>
    jobType.skills.some((skill) =>
      skill.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <>
      <div className="job-types-wrapper">
        <div className="separator"></div>
        <div className="form-group">
          <label>Job Type</label>
          {jobTypeLoading ? (
            <Loader />
          ) : (
            <>
              <div className="dropdown">
                <input
                  type="search"
                  placeholder="Search job types and skills..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                <div className="job-types-list">
                  {jobTypes.map((jobType) => {
                    const filteredSkills = jobType.skills.filter((skill) =>
                      skill.name
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    );

                    if (filteredSkills.length === 0) {
                      return null;
                    }

                    return (
                      <div key={jobType.name} className="job-type-group">
                        <div className="job-type-name">{jobType.name}</div>
                        <div className="skills-under-jobtype">
                          {filteredSkills.map((skill) => (
                            <div key={skill.id}>
                              <label>
                                <input
                                  type="checkbox"
                                  value={skill.id}
                                  checked={selectedSkills.includes(skill.id)}
                                  onChange={() => handleSkillToggle(skill.id)}
                                />
                                <span>{skill.name}</span>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                  {!hasAnyMatch && (
                    <div className="no-skills-found">No skills found.</div>
                  )}
                </div>
              </div>
            </>
          )}
          <div className="selected-skills-wrapper bubble-wrapper-all">
            {selectedSkills.map((skillId) => {
              const skill = jobTypes
                .flatMap((jt) => jt.skills)
                .find((s) => s.id === skillId);

              if (!skill) return null;

              return (
                <div className="bubble-remove-all" key={skillId}>
                  <button
                    type="button"
                    onClick={() => handleSkillToggle(skillId)}
                  >
                    <img src={closeIcon} alt="close-icon" />
                  </button>
                  {skill.name}
                </div>
              );
            })}
            <input
              type="hidden"
              name="skills"
              value={JSON.stringify(selectedSkills)}
            />
          </div>
        </div>
        <div className="separator"></div>
      </div>
    </>
  );
}
